import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DOMPurify from 'dompurify';
import {
  config,
  BloodDonationConstants } from
"../../utils/constants";
import MakeBloodDonation from "./MakeBloodDonation";
import WelcomeQuestionStep1 from "./WelcomeQuestionStep1";
import QuestionStep2 from "./QuestionStep2";
import QuestionStep3 from "./QuestionStep3";
import QuestionStep4 from "./QuestionStep4";
import QuestionStep5 from "./QuestionStep5";
import QuestionStep6 from "./QuestionStep6";
import {
  generateBarCode,
  getCardProfileDataByEmiratesId,
  getPastDonationData,
  getSubmmitedBarCodeDataDetails,
  getWebContent,
  getIdamUserDetails,
  getDonorDetailsByUserName,
  getDonorPastDonations,
  getSubmitedBarCodeDataDetailsByUserName } from
"../../services/epic/bloodDonation";
import QuestionnaireQrCode from "./QuestionnaireQrCode";
import Registration from "./Registration";
import BloodDonationSummary from "./BloodDonationSummary";
import { BloodDonationWebContent, initialStateBloodDonation } from "../../utils/constants";
import {
  configureFirstIframe,
  checkIfUserIsLoggedIn,
  getLocalStorage,
  getCurrentLocale, isLoggedIn, isLiferayEnv } from
"../../utils/util";
import { getLiferayUserScreenName } from "../../utils/themeDisplay";
import { getUserEmail, getUserMrn, getUserNameMyChart } from "../../services/liferay/common";
import DonationSummary from "./donationSummary/DonationSummary";
import { getUserDetailsForBloodDonation } from "../../services/epic/bloodDonation";
import { Loader } from "../../common/Loader";
import { getLayoutDirection } from "../../utils/util";
import DonationExist from "./DonationExist";
import { isMobileApp } from "../../utils/util";

const BloodDonationDashboard = ({
  linkSuccessful,
  setLinkSuccessful,
  setEmail,
  requestStep,
  setRequestStep,
  translationMap,
  email
}) => {
  const [mobileNum, setMobileNumber] = useState("");
  const [submittedAnswerDataRequest, setSubmittedAnswerDataRequest] =
  useState();
  const [barCode, setBarCode] = useState("");
  const [pastDonation, setPastDonation] = useState();
  const [cardProfile, setCardProfile] = useState();
  const [isLiferay, setIsLiferay] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [donorDetails] = useState(null);
  const [id, setId] = useState(null);
  const [pastDonationLength, setPastDonationLength] = useState(0);
  const [submittedAnswerData, setSubmittedAnswerData] = useState(initialStateBloodDonation);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      //setLoading(true);
      try {
        getWebContentDashboard();
        await userDetailsLiferay();
      } catch (error) {


        //console.error("Error fetching initial data:", error);
      } finally {setLoading(false);}
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchInfo = async () => {
      const localStorageValue = getLocalStorage("loginAccount");
      const info = await getDonorDetailsByUserName();
      const mobileNo = info?.data?.mobileNumber;
      setMobileNumber(mobileNo);
      if (localStorageValue && info?.data) {
        setShowLogin(false);
        setRequestStep(2);
        localStorage.removeItem("loginAccount");
      } else if (localStorageValue) {
        setShowLogin(false);
        setRequestStep(1);
        localStorage.removeItem("loginAccount");
      }
    };
    if (isLiferayEnv() && isLoggedIn())
    {
      fetchInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardProfile]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        if (requestStep === -1)
        {
          getWebContentDashboard();
        }
        if ((cardProfile || userName) && requestStep === -1) {
          await Promise.all([
          fetchUpcomingDonationDetails(),
          cardProfile ? fetchPastDonation(cardProfile?.eid, cardProfile?.card, userName) : Promise.resolve()]
          );
        }
      } catch (error) {


        //console.error("Error fetching details:", error);
      } finally {setLoading(false);}
    };
    fetchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardProfile, barCode, requestStep, userName]);

  const getWebContentDashboard = () => {
    let webStructurePKWhereToDonate;
    if (getCurrentLocale() === "en" || getCurrentLocale() === 'en_US')
    {
      webStructurePKWhereToDonate = BloodDonationWebContent.webStructurePKWhereToDonate;
    } else
    {
      webStructurePKWhereToDonate = BloodDonationWebContent.webStructurePKWhereToDonate_ar;
    }
    const templateIdWhereToDonate =
    BloodDonationWebContent.templateIdWhereToDonate;

    getWebContent(webStructurePKWhereToDonate, templateIdWhereToDonate)
    .then((result) => {
      if (result) {
        // setWebContent(result?.data);
        const element = document.querySelector("#whereToDonate");
        const sanitizedContent = DOMPurify.sanitize(result?.data);
        //setWebContent(sanitizedContent);
        element.innerHTML = sanitizedContent;
      } else {


        //setWebContent("Content not found");
      }}).catch((error) => {
    });
  };

  const userDetailsLiferay = async () => {
    const result = checkIfUserIsLoggedIn();
    if (result !== BloodDonationConstants?.NOT_LIFERAY) {
      setIsLiferay(true);
    }
    if (result === BloodDonationConstants?.NOT_lOGGED_IN) {
      setShowLogin(true);
    } else if (result === BloodDonationConstants?.LOGGED_IN) {
      setIsLogin(true);
    }
    if (
    result !== BloodDonationConstants?.NOT_lOGGED_IN &&
    result !== BloodDonationConstants?.LOGGED_IN)
    {
      // Not liferay
      const name = getUserNameMyChart();
      setUserName(name);
      const email = getUserEmail();
      if (email?.trim())
      {
        setEmail(email);
      }
      const mrn = getUserMrn();
      if (mrn)
      {
        const result = await getUserDetailsForBloodDonation();
        if (result?.data?.patientAEID) {
          await fetchCardProfileByEmiratesId(result.data.patientAEID, userName);
        }
      }
    } else {
      // liferay
      getLiferayUserScreenName((screenName) => {
        setUserName(screenName);
        if (screenName)
        {
          getIdamUserDetails().then(async (result) => {
            const email = result?.data?.items[0]?.idamUserEmail;
            if (email?.trim()) {
              setEmail(email);
            }
            await fetchDonorDetailsByUserName();
          });
        }
      });
    }
  };

  const fetchPastDonation = async (emiratedId, donorId, userName) => {
    try {
      const result = await getPastDonationData(emiratedId);
      if (result == null) {
        setPastDonation(null);
      } else if (result?.data && result?.data?.donations.length === 0) {
        setPastDonation([]);
      } else {
        const donations = result?.data?.donations || [];
        //console.log("donations from emirates Id", donations);
        setPastDonation(donations);
        const donorData = await fetchPastDonorDonation(donorId, userName);
        //console.log("donations from donorData", donorData);
        const donationLength = donorData?.pastDonations || 0;
        const totalLength = donationLength + donations.length;
        //console.log("total length", totalLength);
        setPastDonationLength(totalLength);
      }
    } catch (error) {
      // console.error("Error fetching past donations:", error);
      setPastDonation(null);
    }
  };

  const fetchCardProfileByEmiratesId = async (emiratedId, userName) => {
    try {
      const result = await getCardProfileDataByEmiratesId(emiratedId, userName);
      if (result?.data == null) {
        //console.log("Profile not found");
        setCardProfile(null);
      } else {
        //console.log("Card Profile data result", result);
        setCardProfile(result?.data);
      }
    } catch (error) {
      // console.error("Error fetching card profile:", error);
      setCardProfile(null);
    }
  };

  const fetchPastDonorDonation = async (donorId) => {
    try {
      const result = await getDonorPastDonations(donorId);
      if (result && result?.data && result?.data?.items[0]) {
        return result?.data?.items[0];
      }
      return null;
    } catch (error) {


      //console.error("Error fetching past donations:", error);
    }};
  const fetchBarCode = async (barCodeContent) => {
    try {
      const response = await generateBarCode(barCodeContent);
      //console.log("Bar code response in dashboard >> ", response);
      setBarCode(response.data.barcode);
    } catch (err) {


      // console.error("Error fetching barcode:", err);
    }};
  const fetchUpcomingDonationDetails = async () => {
    try {
      const response = await getSubmitedBarCodeDataDetailsByUserName();
      //console.log("fetch upcoming donation details method response ", response);
      const barcodeData = response?.data;
      const barCodeAnswerResult = barcodeData?.barCodeAnswerResult;
      if (barcodeData) {
        const isBarcodeValidToday = isToday(barcodeData.dateModified);
        //console.log("result of valid barcode", isBarcodeValidToday);
        if (isBarcodeValidToday) {
          fetchBarCode(barCodeAnswerResult);
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (err) {
      // console.error("Error fetching barcode:", err);
      return false;
    }
  };

  const fetchUpcomingDonationDetailsByMobileNo = async (mobileNo) => {
    try {
      const response = await getSubmmitedBarCodeDataDetails(mobileNo);
      //console.log("fetch upcoming donation details by mobileNo", response);
      const barcodeData = response?.data;
      const barCodeAnswerResult = barcodeData?.barCodeAnswerResult;
      if (barcodeData) {
        const isBarcodeValidToday = isToday(barcodeData.dateModified);
        // console.log("result of valid barcode", isBarcodeValidToday);
        if (isBarcodeValidToday) {
          fetchBarCode(barCodeAnswerResult);
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (err) {
      //  console.error("Error fetching barcode:", err);
      return false;
    }
  };

  const fetchDonorDetailsByUserName = async () => {
    getDonorDetailsByUserName()
    .then((result) => {
      if (result?.data) {
        // console.log(
        //   "donor details details in dashboard",
        //   result?.data
        // );
        setCardProfile(result?.data);
      } else {
        setCardProfile(null);
      }
    })
    .catch(() => setCardProfile(null));
  };

  const isToday = (dateString) => {
    const createdDate = new Date(dateString);
    const today = new Date();

    return (
      createdDate.getUTCFullYear() === today.getUTCFullYear() &&
      createdDate.getUTCMonth() === today.getUTCMonth() &&
      createdDate.getUTCDate() === today.getUTCDate());

  };

  const handleClick = (title) => {
    if (title !== "Blood Donation Center") {
      configureFirstIframe(500, 2350);
      if (getCurrentLocale() === "en" || getCurrentLocale() === 'en_US')
      {
        navigate(
          `/detail/${BloodDonationWebContent.webStructurePKProcess}/${BloodDonationWebContent.templateIdProcess}`
        );
      } else
      {
        navigate(
          `/detail/${BloodDonationWebContent.webStructurePKProcess_ar}/${BloodDonationWebContent.templateIdProcess}`
        );
      }
    } else {
      configureFirstIframe(500, 750);
      if (getCurrentLocale() === "en" || getCurrentLocale() === 'en_US')
      {
        navigate(
          `/detail/${BloodDonationWebContent.webStructurePKCenter}/${BloodDonationWebContent.templateIdCenter}`
        );
      } else
      {
        navigate(
          `/detail/${BloodDonationWebContent.webStructurePKCenter_ar}/${BloodDonationWebContent.templateIdCenter}`
        );
      }
    }
    window.parent.scrollTo(0, 0);
  };

  const handleBloodDonation = () => {
    if (donorDetails || cardProfile) {
      //console.log("card profile in dashboard if", cardProfile?.mobileNumber);
      setMobileNumber(cardProfile?.mobileNumber);
      setRequestStep(2);
    } else {
      setRequestStep(1);
    }
  };

  const handleCancel = () => {
    setRequestStep(-1);
    window.parent.scrollTo(0, 0);
    setSubmittedAnswerData(initialStateBloodDonation);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className={` custombody_color ${getLayoutDirection()}`}>
        {requestStep === -1 &&
        <>
              <section
            className="w-100 clearfix BloodDonationMainSection"
            id="CoverPlanActive">
            
                <div className="container customContainer">
                  {!isMobileApp() &&

              <div className="Title_Inner_Box">
                            <h1 className="MainTitleOne">{translationMap?.dammi}</h1>
                          </div>
              }
                  <div className="cover_inner_wrapper cover_inner_wrapper2">
                    <div className="cover_main_box1">
                      <div className="Optimized_Main_Wrap_Box Optimized_Main_Wrap_Box2">
                        <div className="blood_dashboard_inner_wrap">
                          {linkSuccessful &&
                      <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                              <button
                          type="button"
                          className="close"
                          data-dismiss="alert"
                          onClick={() => setLinkSuccessful(false)}>
                          
                                &times;
                              </button>
                              <div className="Icon_box">
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <a>
                                  <span className="material-symbols-outlined">
                                    check_circle
                                  </span>
                                </a>
                              </div>
                              <div className="alert_text">
                                <h6>
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                  <a>
                                    {translationMap?.linkSuccessful ||
                              "Donor account linked successfully."}
                                  </a>
                                </h6>
                              </div>
                            </div>
                      }
                          <div className="title_box responsive_title_box2">
                            <h6 className="MainTitleOne">
                              {translationMap?.welcomeToDammi}
                            </h6>
                          </div>
                          <div className="make_dasboard_inner_box">
                            <div className="make_donation_box active_donation_tab">
                              <div className="inner_box1">
                                <div className="date_box">
                                  <svg
                                width="20"
                                height="22"
                                viewBox="0 0 26 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                
                                    <path
                                  d="M9 23.6666L17 23.6666M6.33333 19L19.6667 19M3.66667 1.66663L22.3333 1.66663C23.8061 1.66663 25 2.99319 25 4.62959L25 25.3703C25 27.0067 23.8061 28.3333 22.3333 28.3333L3.66667 28.3333C2.19391 28.3333 1 27.0067 1 25.3703L1 4.62959C1 2.99319 2.19391 1.66663 3.66667 1.66663ZM12.9968 7.28254C12.0638 6.24369 10.5079 5.96424 9.33886 6.91552C8.16983 7.8668 8.00525 9.45728 8.92329 10.5824C9.84133 11.7074 12.9968 14.3333 12.9968 14.3333C12.9968 14.3333 16.1523 11.7074 17.0703 10.5824C17.9884 9.45728 17.8439 7.85679 16.6548 6.91552C15.4656 5.97425 13.9298 6.24369 12.9968 7.28254Z"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round" />
                                
                                  </svg>
                                </div>
                                <div className="content_box">
                                  <h6 className="MainTitleOne">
                                    {translationMap?.makeDonation}
                                  </h6>
                                  <p className="para_txt">
                                    {translationMap?.makeDonationMessage}
                                  </p>
                                </div>
                              </div>
                              <div className="inner_box2">
                                <div className="btn_innerwrap">
                                  <div className="common_btn_box">
                                    <button
                                  onClick={handleBloodDonation}
                                  className="bluetrans_btn_link bluetrans_btn_link_sm">
                                  
                                      {translationMap?.makeBloodDonation}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="make_donation_box">
                              <div className="inner_box1">
                                <div className="date_box">
                                  <svg
                                width="20"
                                height="22"
                                viewBox="0 0 20 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                
                                    <path
                                  d="M7 17.5L13 17.5M5 14L15 14M3 1L17 1C18.1046 1 19 1.99492 19 3.22222L19 18.7778C19 20.0051 18.1046 21 17 21L3 21C1.89543 21 1 20.0051 1 18.7778L1 3.22222C1 1.99492 1.89543 1 3 1ZM9.9976 5.21194C9.29783 4.4328 8.13091 4.22321 7.25414 4.93667C6.37738 5.65013 6.25394 6.84299 6.94247 7.6868C7.631 8.53061 9.9976 10.5 9.9976 10.5C9.9976 10.5 12.3642 8.53061 13.0527 7.6868C13.7413 6.84299 13.6329 5.64262 12.7411 4.93667C11.8492 4.23072 10.6974 4.4328 9.9976 5.21194Z"
                                  stroke="#002F70"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round" />
                                
                                  </svg>
                                </div>
                                <div className="content_box">
                                  <h6 className="MainTitleOne">
                                    {translationMap?.registerForEmergencies}
                                  </h6>
                                  <p className="para_txt">
                                    {translationMap?.registerForEmergenciesMsg}
                                  </p>
                                </div>
                              </div>
                              <div className="inner_box2">
                                <div className="btn_innerwrap">
                                  <div className="common_btn_box">
                                    <button
                                  onClick={() => setRequestStep(9)}
                                  className="bluetrans_btn_link bluetrans_btn_link_sm">
                                  
                                      {translationMap?.registerNow}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="dashboard_inner_main_box">
                            <div className="title_txt">
                              <h6 className="MainTitleOne">
                                {translationMap?.learnMore}
                              </h6>
                            </div>

                            <div className="learn_more_donation_box">
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a onClick={() => {
                            handleClick("Blood Donation Center");
                            window.parent.scrollTo(0, 0);
                          }} className="learn_more_inner_box">
                                <div className="learn_box_1">
                                  <img
                                src={`${config.assestsBase}img/blood_donation_center.png`}
                                alt="Blood donation center logo" />
                              
                                </div>
                                <div className="learn_box_2">
                                  <h6 className="MainTitleOne">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a>{translationMap?.dbdCenter}</a>
                                  </h6>
                                  <p>{translationMap?.learnMoreAboutDBD}</p>
                                </div>
                                <div className="learn_box_3">
                                    <span className="material-symbols-outlined">
                                      arrow_forward_ios
                                    </span>
                                </div>
                              </a>
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a onClick={() => {
                            handleClick("Blood Donation Process");
                            window.parent.scrollTo(0, 0);
                          }} className="learn_more_inner_box">
                                <div className="learn_box_1">
                                  <img
                                src={`${config.assestsBase}img/process.png`}
                                alt="Blood donation process logo" />
                              
                                </div>
                                <div className="learn_box_2">
                                  <h6 className="MainTitleOne">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a>{translationMap?.donationProcess}</a>
                                  </h6>
                                  <p>
                                    {translationMap?.learnMoreAboutDBDProcess}
                                  </p>
                                </div>
                                <div className="learn_box_3">
                                    <span className="material-symbols-outlined">
                                      arrow_forward_ios
                                    </span>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div className="dashboard_inner_main_box">

      <div id="whereToDonate"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <BloodDonationSummary
                  setRequestStep={setRequestStep}
                  barCode={barCode}
                  pastDonation={pastDonation}
                  cardProfile={cardProfile}
                  showLogin={showLogin}
                  isLiferay={isLiferay}
                  isLogin={isLogin}
                  donorDetails={donorDetails}
                  pastDonationLength={pastDonationLength}
                  userName={userName}
                  translationMap={translationMap} />
                
                  </div>
                </div>
              </section>
          </>
        }
        {requestStep === 1 &&
        <MakeBloodDonation
          setRequestStep={setRequestStep}
          setMobileNumber={setMobileNumber}
          mobileNum={mobileNum}
          isLiferay={isLiferay}
          showLogin={showLogin}
          id={id}
          setId={setId}
          userDetailsLiferay={userDetailsLiferay}
          fetchUpcomingDonationDetailsByMobileNo={fetchUpcomingDonationDetailsByMobileNo}
          cardProfile={cardProfile}
          translationMap={translationMap} />

        }
        {requestStep === 2 &&
        <WelcomeQuestionStep1
          setRequestStep={setRequestStep}
          requestStep={requestStep}
          donorDetails={donorDetails}
          cardProfile={cardProfile}
          loading={loading}
          setLoading={setLoading}
          setSubmittedAnswerData={setSubmittedAnswerData}
          handleCancel={handleCancel}
          translationMap={translationMap} />

        }
        {requestStep === 3 &&
        <QuestionStep2
          setRequestStep={setRequestStep}
          mobileNum={mobileNum}
          setSubmittedAnswerDataRequest={setSubmittedAnswerDataRequest}
          requestStep={requestStep}
          loading={loading}
          setLoading={setLoading}
          submittedAnswerData={submittedAnswerData}
          setSubmittedAnswerData={setSubmittedAnswerData}
          handleCancel={handleCancel}
          userName={userName}
          translationMap={translationMap} />

        }
        {requestStep === 4 &&
        <QuestionStep3
          setRequestStep={setRequestStep}
          submittedAnswerDataRequest={submittedAnswerDataRequest}
          setSubmittedAnswerDataRequest={setSubmittedAnswerDataRequest}
          requestStep={requestStep}
          loading={loading}
          setLoading={setLoading}
          submittedAnswerData={submittedAnswerData}
          setSubmittedAnswerData={setSubmittedAnswerData}
          handleCancel={handleCancel}
          translationMap={translationMap} />

        }
        {requestStep === 5 &&
        <QuestionStep4
          setRequestStep={setRequestStep}
          submittedAnswerDataRequest={submittedAnswerDataRequest}
          setSubmittedAnswerDataRequest={setSubmittedAnswerDataRequest}
          requestStep={requestStep}
          loading={loading}
          setLoading={setLoading}
          submittedAnswerData={submittedAnswerData}
          setSubmittedAnswerData={setSubmittedAnswerData}
          handleCancel={handleCancel}
          translationMap={translationMap} />

        }
        {requestStep === 6 &&
        <QuestionStep5
          setRequestStep={setRequestStep}
          submittedAnswerDataRequest={submittedAnswerDataRequest}
          setSubmittedAnswerDataRequest={setSubmittedAnswerDataRequest}
          requestStep={requestStep}
          loading={loading}
          setLoading={setLoading}
          submittedAnswerData={submittedAnswerData}
          setSubmittedAnswerData={setSubmittedAnswerData}
          handleCancel={handleCancel}
          translationMap={translationMap} />

        }
        {requestStep === 7 &&
        <QuestionStep6
          setRequestStep={setRequestStep}
          mobileNum={mobileNum}
          submittedAnswerDataRequest={submittedAnswerDataRequest}
          requestStep={requestStep}
          loading={loading}
          setLoading={setLoading}
          submittedAnswerData={submittedAnswerData}
          handleCancel={handleCancel}
          userName={userName}
          translationMap={translationMap}
          email={email}
          />

        }
        {requestStep === 8 &&
        <QuestionnaireQrCode
          setRequestStep={setRequestStep}
          mobileNum={mobileNum}
          submittedAnswerDataRequest={submittedAnswerDataRequest}
          loading={loading}
          setLoading={setLoading}
          setSubmittedAnswerData={setSubmittedAnswerData}
          cardProfile={cardProfile}
          setBarCode={setBarCode}
          handleCancel={handleCancel}
          translationMap={translationMap} />

        }
        {requestStep === 9 &&
        <Registration
          setRequestStep={setRequestStep}
          translationMap={translationMap} />

        }
        {requestStep === 11 &&
        <DonationSummary
          setRequestStep={setRequestStep}
          barCode={barCode}
          pastDonation={pastDonation}
          loading={loading}
          setLoading={setLoading}
          translationMap={translationMap} />

        }
        {requestStep === 12 &&
        <DonationExist
          setRequestStep={setRequestStep}
          barCode={barCode}
          translationMap={translationMap} />

        }
      </div>
    </>);

};

export default BloodDonationDashboard;